import { format as i } from "../util.mjs";
var r = function(s, e, o, t, a) {
  (/^\s+$/.test(e) || e === "") && t.push(i(a.messages.whitespace, s.fullField));
};
export {
  r as default
};
//# sourceMappingURL=whitespace.mjs.map
